import type { FC } from 'react';
import { useTranslation } from 'next-i18next';
import { Divider, Drawer, Typography } from 'antd';
import styled from 'styled-components';

import { AssetCategoryToText, AssetsForms } from '@/entities/assets';
import { Container } from '@/shared/components/layout';
import { COLORS } from '@/shared/constants/colors';
import { useAppRouter } from '@/shared/hooks/app/useAppRouter';
import { AssetCategory } from '@/shared/lib/sj-orm/models/asset.dto';

import { useModalsStore } from '../../modals.store';
import { SelectAssetCategoryProps } from '../../types';

export const SelectAssetCategory: FC<SelectAssetCategoryProps> = ({ onSelect }) => {
  const { t } = useTranslation(['common', 'assets']);
  const router = useAppRouter();
  const modals = useModalsStore();

  const onSelectCategory = async (category: AssetCategory) => {
    modals.closeModal();

    if (!onSelect) {
      await router.pushShallow(`/assets/create/${category}`);
    } else {
      onSelect(category);
    }
  };

  return (
    <StyledDrawer
      open={true}
      height={'90vh'}
      placement="bottom"
      closable={false}
      onClose={modals.closeModal}
    >
      <Divider style={{ margin: 0 }} />
      <Container paddingX={24} paddingY={16}>
        <DrawerTitle>Choose Asset category</DrawerTitle>
      </Container>
      <Divider style={{ margin: 0 }} />
      {Object.entries(AssetsForms).map(([assetCategory]) => (
        <>
          <Divider style={{ margin: 0 }} />
          <Container paddingX={24} paddingY={16} style={{ cursor: 'pointer' }}>
            <Typography.Title
              level={4}
              key={assetCategory}
              onClick={() => onSelectCategory(assetCategory as AssetCategory)}
              data-testid={`${assetCategory}`}
            >
              {t(AssetCategoryToText[assetCategory as AssetCategory])}
            </Typography.Title>
          </Container>
          <Divider style={{ margin: 0 }} />
        </>
      ))}
    </StyledDrawer>
  );
};

const StyledDrawer = styled(Drawer)`
  &&& {
    .ant-drawer-body {
      padding: 0;
    }
  }
`;

const DrawerTitle = styled(Typography.Text)`
  &&& {
    font-size: 16px;
    color: ${COLORS.colorTextTertiary};
  }
`;
